import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

import logger from '@/infra/logger';

export default async function pressHaptic(
  type?:
    | 'notificationError'
    | 'impactMedium'
    | 'impactLight'
    | 'impactHeavy'
    | 'notificationSuccess',
) {
  try {
    if (type === 'notificationError') {
      await Haptics.notification({ type: NotificationType.Error });

      return;
    }

    if (type === 'impactHeavy') {
      await Haptics.impact({ style: ImpactStyle.Heavy });

      return;
    }

    if (type === 'impactMedium') {
      await Haptics.impact({ style: ImpactStyle.Medium });

      return;
    }

    if (type === 'notificationSuccess') {
      await Haptics.notification({ type: NotificationType.Success });

      return;
    }

    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (error) {
    logger.captureException(error);

    return error;
  }
}
